import { apiClient } from '../../../gateways/api'
import type { HoofdleidingProject } from '../types/HoofdleidingProject'

export { fetchProject }

const fetchProject = async ({
  id,
}: {
  id: string
}): Promise<HoofdleidingProject> => {
  const { data } = await apiClient({
    url: `/rest/project/${id}`,
    method: 'GET',
  })

  return data
}
